<template>
  <div class="row">
    <div v-for="f in fields" :key="f.key" :class="f.class">
      <div class="form-group" :class="{ 'has-error': f.error }"
           v-show="f.show == null || f.show(model)">
        <label :for="f.key" class="control-label">
          {{f.label}}
        </label>
        <p class="yes-no-text" v-html="f.text"></p>
        <span v-if="f.type === 1" :id="f.key">
          <c-checkbox v-for="c in f.choices"
                      :key="`${c.key}-choice`"
                      type="reaExplaur"
                      :disabled="waiting"
                      v-model="check[f.key][c.key]" size="xs"
                      @input="toggle(f.key, f.choices, c.key)">
            {{c.label}}
          </c-checkbox>
        </span>
        <span v-else>
          <span v-if="f.options">
            <cleave v-model.trim="model[f.key].value"
                    :options="f.options"
                    class="form-control"
                    :disabled="waiting"
                    autocomplete="off"
                    :placeholder="f.placeholder"
                    @blur="f.blur(model[f.key], model)"
                    :name="f.key">
            </cleave>
          </span>
          <span v-else>
            <input required
                   :id="f.key"
                   class="form-control"
                   :disabled="waiting"
                   v-model.trim="model[f.key].value"
                   type="text"
                   @blur="f.blur(model[f.key], model)"
                   :placeholder="f.placeholder"/>
          </span>
        </span>
        <span class="text-danger help-block">{{ model[f.key].error }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import cleave from 'vue-cleave-component'
import checkbox from '@/sui/components/checkbox'

export default {
  name: 'sui-field-list',

  props: {
    fields: {
      type: Array,
      required: true
    },

    value: {
      type: Object,
      required: true
    },

    waiting: {
      type: Boolean,
      default: false
    }
  },

  data: function () {
    const check = {}
    this.fields.forEach(
      f => {
        if (f.type === 1) {
          const o = {}
          const v = this.value[f.key]
          if (v == null) {
            return
          }
          f.choices.forEach(
            c => {
              o[c.key] = v.value === c.value
            }
          )
          check[f.key] = o
        }
      }
    )

    return {
      model: this.value,
      check: check
    }
  },

  watch: {
    model: function () {
      this.$emit('input', this.model)
    }
  },

  methods: {
    toggle: function (fk, ch, ck) {
      const c = this.check[fk]
      const v = this.model[fk]

      let sum = 0
      ch.forEach(i => { sum += c[i.key] })
      if (sum !== 1) {
        ch.forEach(
          i => {
            if (i.key !== ck) {
              c[i.key] = false
            }
          }
        )
      }

      v.value = ''
      ch.forEach(
        i => {
          if (c[i.key]) {
            v.value = i.value
          }
        }
      )
    }
  },

  components: {
    'cleave': cleave,
    'c-checkbox': checkbox
  }
}
</script>
<style scoped lang="less">
@import '~variables';

.has-error .control-label {
  color: @brand-danger;
}

.has-error .help-block {
  color: @brand-danger;
}

.c-checkbox {
  margin-right: 1rem;
}

.yes-no-text {
  opacity: 0.7;
  font-size: 80%;
}
</style>
